<template>
  <div class="homemobile">
    <br><br><br><br>
      <b-container fluid style="padding-top: 100px;width:100%">
        <b-row >
          <b-col cols="12" sm="12" md="12" lg="12"><HeaderMobile/></b-col>
        </b-row>

        <!-- <b-row style="margin-top: -6rem;">
          <b-col cols="12" class="banner-pc"><Banner/></b-col>
          <b-col cols="3" class="payment-pc"><Payment/></b-col>
        </b-row> -->


        <b-row style="margin-top: -8rem;">
          <b-col cols="12" class="banner-mb"><Banner/></b-col>
        </b-row>
        <b-row class="mt-2">
        <b-col cols="12">
          <div class="app-update-ribbon">
            <b-icon icon="info-circle-fill" class="mr-2"></b-icon>
            <span>
              <strong>myBijulee</strong> মোবাইল এপ্লিকেশনৰ এণ্ড্ৰইড সংস্কৰণ ব্যৱহাৰ কৰাৰ সময়ত কোনো অসুবিধাৰ সন্মুখীন হোৱা ব্যৱহাৰকাৰীসকলক 
              <strong>গুগল প্লে ষ্টোৰত উপলব্ধ শেহতীয়া সংস্কৰণলৈ</strong> এপ্লিকেশ্যনটো আপডেট কৰিবলৈ এইদ্বাৰা অৱগত কৰা হৈছে।
            </span>
          </div>
        </b-col>
      </b-row>
        <b-row>
          <b-col cols="12">
            <router-link
              to="/ContactCustomerCare"
              custom
              target="_blank"
              class="customer-support-banner"
            >
              <div>
                For any electricity-related issues, contact our <strong>24x7 Customer Support</strong> at
                <strong>1912 (Calls originating from within Assam) /   0361–3126201 or 0361-2803200  (Calls originating from outside Assam)</strong> or email at
                <strong>support@apdcl.org</strong>
              </div>
              <div style="margin-top: 8px;">
                (বিদ্যুৎ সম্পৰ্কীয় যিকোনো সমস্যাৰ বাবে আমাৰ <strong>২৪x৭ গ্ৰাহক সহায়ক নম্বৰ </strong>
                <strong>১৯১২ (অসমৰ পৰা অহা ফোন কলৰ বাবে) /০৩৬১–৩১২৬২০১ বা ০৩৬১–২৮০৩২০০ (অসমৰ বাহিৰৰ পৰা অহা ফোন কলৰ বাবে)</strong> বা
                <strong>support@apdcl.org</strong> ই-মেইলত যোগাযোগ কৰক)
              </div>
            </router-link>
          </b-col>
        </b-row>
        <b-row style="color:#424242;height:2vh; margin-top:2vh;margin-bottom:0vh" >
             <marquee loop="2" style="display:block">
               <span v-for="item in getMarquee" :key="item.title">
                 <span class="m-text"  v-html="item.title"></span>
                 <span>
                    |
                  </span>
               </span>
            </marquee>
         </b-row>
        <br>
        <b-row>
          <b-col cols="12" class="payment-mb"><MobilePayment/></b-col>
        </b-row>
<br>

      <!-- <b-row style="margin-left:-30px; margin-right:-30px;padding-top:4vh">
          <b-col lg="12" sm="12">  <MobileBottomFixedNav/></b-col>
      </b-row> -->
      <b-row style="padding-top:">
          <b-col cols="12">  <HomepageMobileCardComponents/> </b-col>
      </b-row>
      <br>

      <b-row style="padding-top:10px">
          <b-col cols="12">  <FooterMobile/> </b-col>
      </b-row>
      </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import Banner from '@/components/HomeBanner.vue'
import MobilePayment from '@/components/AS_HomeMobilePayment.vue'
import MobileBottomFixedNav from '@/components/HomeMobileBottomFixedNav.vue'
import HomepageMobileCardComponents from '@/components/AS_HomeMobileCardComponents.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'
import FooterMobile from '@/components/AS_FooterMobile.vue'
//import MarqueeText from 'vue-marquee-text-component'
//console.log(Banner);
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'HomeMobile',
  components: {
    'Banner' : Banner,
    'MobilePayment' : MobilePayment,
    'MobileBottomFixedNav' : MobileBottomFixedNav,
    'HomepageMobileCardComponents' : HomepageMobileCardComponents,
    'HeaderMobile' : HeaderMobile,
    'FooterMobile' : FooterMobile
    //MarqueeText

  },

data() {
    return {
     getMarqueeFields: [
         { key: 'title', label: '' }

       ]
    }

},
computed:
{
  ...mapGetters([
    'getMarquee'
  ])
},
methods: {
  ...mapActions([
    'retrieveMarquee'

  ]),
},
beforeMount() {
    if(this.getMarquee.length == 0){
      this.retrieveMarquee();

    }
}
}

</script>


<style>
.app-update-ribbon {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  background: linear-gradient(90deg, #fff3e0, #ffcc80);
  color: #e65100;

  padding: 12px 16px;
  border-left: 6px solid #fb8c00;
  border-radius: 6px;

  font-size: 0.85rem;
  font-weight: 600;

  text-align: center;
  margin-bottom: 10px;
  margin-left: 20px;

  /* Pulse animation */
  animation: pulse-orange 1s infinite;
}

@keyframes pulse-orange {
  0% {
    box-shadow: 0 0 0 0 rgba(251, 140, 0, 0.45); /* orange */
  }
  70% {
    box-shadow: 0 0 0 10px rgba(245, 124, 0, 0.4); /* deep orange */
  }
  100% {
    box-shadow: 0 0 0 0 rgba(251, 140, 0, 0);
  }
}

.app-update-ribbon svg {
  margin-right: 2px;
  font-size: 0.95rem;
}
.customer-support-banner {
  display: block;
  background-color: #fff8e1; /* sticky-note look */
  /* border-left: 6px solid #ff9800; */
  border-left: 6px solid #0277bd;
  border-right: 6px solid #0277bd;
  border-top: 6px solid #0277bd;
  border-bottom: 6px solid #0277bd;
  /* padding: 16px 20px; */
  border-radius: 10px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.15);
  color: #333;
  text-decoration: none;
  font-weight: 500;
  line-height: 1.6;
  /* max-width: 1000px; */
  /* margin: 10px auto; */
  margin-top: 10px;
  margin-bottom: 5px;
  transition: all 0.2s ease-in-out;
}

.customer-support-banner:hover {
  background-color: #ffecb3;
  box-shadow: 4px 6px 14px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
  cursor: pointer;
}

.customer-support-banner .support-line {
  display: block;
  font-size: 1rem;
  margin-bottom: 4px;
}
.homeMobile {
  margin-top: -25px;
  height:102vh;
  background-image: url('../assets/bg4.jpg');

 background-repeat: no-repeat;
 background-attachment: fixed;
 background-size: 100% 100%;
 box-shadow:inset 0 0 0 2000px  #ffffffbf;;

}
.banner-mb{
  /* display:none; */
  display: block;
}
.payment-mb{
  display:block;
}

/* @media only screen and (max-width: 768px) {
  .banner-pc{
    display:none;
  }
  .payment-pc{
    display:none;
  }
  .banner-mb{
    display:block;
  }
  .payment-mb{
    display:block;
  }
} */
.m-text{
  padding:10px 10px 0px 10px;
}
@media (min-width: 768px) {

  }
@media only screen and (max-width: 600px) {
  /* body {
    background-color: lightblue;
  } */
}
@font-face {
  font-family: Assamese_Font;
  src: url("../assets/Assamese_font/KirtanUni.ttf");
}
div{
    font-family: arial, Assamese_Font;
}

</style>
